"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataCardLabel = exports.MultiDataCardItem = exports.SecondaryLabel = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Card_1 = require("@/components/dataCard/Card");
const FoundationHoldings_1 = require("@/pages/home/sections/FoundationHoldings");
const locale = 'en-US';
const Overview = ({ data, isPageLoading }) => {
    const order = {
        'reward Rate': 4,
        vested: 2,
        staked: 3,
        unlocked: 5,
        'unclaimed Tokens': 6,
        total: 1,
    };
    if (data && !isPageLoading) {
        return (react_1.default.createElement(Card_1.Card, { radius: 25, bg: 'gradientBg', amountSize: FoundationHoldings_1.AmountSize.Big, isborder: true, data: {}, key: data.name, cardwidth: {
                xs: 12,
                sm: 12,
                md: 12,
                lg: 12,
                xl: 12,
            } }, data.children.map((e, i) => e.name !== 'Reward Rate' && (react_1.default.createElement(Card_1.Card, { radius: 20, bg: 'bg', amountSize: FoundationHoldings_1.AmountSize.Medium, isborder: true, data: e, key: `${e}-${i}`, cardwidth: {
                xs: 12,
                sm: 12,
                md: 6,
                lg: 6,
                xl: 6,
            } }, e.children?.map((element, i) => element && (react_1.default.createElement(Card_1.Card, { horizontal: true, radius: 50, bg: 'contrastBg', amountSize: FoundationHoldings_1.AmountSize.Small, data: element, key: `${element}-${i}`, cardwidth: {
                xs: 12,
                sm: 12,
                md: 12,
                lg: 12,
                xl: 12,
            } }, element.children &&
            element.children?.map((el, i) => (react_1.default.createElement(Card_1.Card, { noPadding: true, horizontal: true, radius: 200, amountSize: FoundationHoldings_1.AmountSize.Small, data: el, bg: 'contrastBg', key: `${el}-${i}`, cardwidth: {
                    xs: 12,
                    sm: 12,
                    md: 12,
                    lg: 12,
                    xl: 12,
                } })))))))))));
    }
};
exports.default = Overview;
const MultiDataCardContainer = (0, styled_components_1.default)('div') `
  background: ${(props) => props.theme.colors.gradientBg};
  display: grid;
  grid-column: span 12;
  grid-template-columns: repeat(12, 1fr);
  padding: ${(props) => props.theme.spacing.margin.md};
  gap: 20px;
  border-radius: 30px;
  ${(props) => props.theme.media.lg} {
    padding: ${(props) => props.theme.spacing.margin.md};
    grid-column: span 12;
  }
  ${(props) => props.theme.media.md} {
    padding: ${(props) => props.theme.spacing.margin.md};
    grid-column: span 12;
  }
  ${(props) => props.theme.media.sm} {
    padding: ${(props) => props.theme.spacing.margin.sm};
    grid-column: span 12;
  }
  ${(props) => props.theme.media.xs} {
    padding: ${(props) => props.theme.spacing.margin.xs};
    grid-column: span 12;
  }
`;
exports.SecondaryLabel = (0, styled_components_1.default)('p') `
  text-transform: capitalize;
  font-size: 0.9em;
`;
exports.MultiDataCardItem = (0, styled_components_1.default)('div') `
  border: 1px solid ${(props) => props.theme.colors.border};
  color: ${(props) => props.theme.colors.onBg};
  font-size: 1em;
  min-width: 200px;
  display: flex;
  background-color: ${(props) => props.theme.colors.bg};
  border-radius: 20px;
  flex-direction: column;
  display: flex;
  padding: ${(props) => props.theme.spacing.margin.sm};
  grid-column: span 4;
  ${(props) => props.theme.media.lg} {
    grid-column: span 4;
  }
  ${(props) => props.theme.media.md} {
    grid-column: span 12;
  }
  ${(props) => props.theme.media.sm} {
    grid-column: span 12;
  }
  ${(props) => props.theme.media.xs} {
    grid-column: span 12;
  }
`;
exports.DataCardLabel = (0, styled_components_1.default)('p') `
  font-size: 1em;
  font-weight: 400;
  text-transform: Capitalize;
  padding-bottom: 5px;
  margin-bottom: 3px;
`;
